import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { CUSTOM_ISSUED_CHECK_TYPE_INPUT, CUSTOM_PURGED_STATUS_INPUT, CUSTOM_STATUS_INPUT, ERROR_STATUS_INPUT } from '../constants/index'
import {
  colorBgAccentGraySubtlest,
  colorBgButtonSubtleHovered,
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgSuccessHovered,
  colorBgWarningHovered,
  colorBlack,
  colorTextSubtle,
  success,
  warning,
} from 'src/app/themes/primaryThemeDefault'

const StatusTag: React.FC<{ status: string }> = (props) => {
  const { status } = props
  const { t } = useTranslation()

  const getConfig = useCallback(
    (status: string) => {
      switch (status) {
        case CUSTOM_STATUS_INPUT.PROCESSED:
        case ERROR_STATUS_INPUT.PROCESSED:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.processed`),
          }
        case CUSTOM_STATUS_INPUT.PROCESSING:
        case ERROR_STATUS_INPUT.PROCESSING:
          return {
            color: warning,
            backgroundColor: colorBgWarningHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.processing`),
          }
        case CUSTOM_STATUS_INPUT.PROCESSED_WITH_EXCEPTION:
        case ERROR_STATUS_INPUT.PROCESSED_WITH_EXCEPTION:
          return {
            color: '#F8C100',
            backgroundColor: '#FFFAE7',
            text: t(`IssuedCheckProcessingLog:result_screen.table.processed_with_exception`),
          }
        case CUSTOM_STATUS_INPUT.REJECTED:
        case ERROR_STATUS_INPUT.REJECTED:
          return {
            color: colorTextSubtle,
            backgroundColor: colorBgButtonSubtleHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.rejected`),
          }
        case CUSTOM_STATUS_INPUT.FAILED:
        case ERROR_STATUS_INPUT.FAILED:
        case ERROR_STATUS_INPUT.FAIL:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.failed`),
          }
        case CUSTOM_PURGED_STATUS_INPUT.ACTIVE:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.active`),
          }
        case CUSTOM_PURGED_STATUS_INPUT.PURGED:
          return {
            color: colorBlack,
            backgroundColor: colorBgAccentGraySubtlest,
            text: t(`IssuedCheckProcessingLog:result_screen.table.purged`),
          }
        case CUSTOM_ISSUED_CHECK_TYPE_INPUT.SUBMITTED:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.submitted`),
          }
        case CUSTOM_ISSUED_CHECK_TYPE_INPUT.SINGLE:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.single`),
          }
        default:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`IssuedCheckProcessingLog:result_screen.table.processed`),
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  return (
    <Flex
      style={{
        borderRadius: 28,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
        fontWeight: '700',
        lineHeight: 20,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          minWidth: 4,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default StatusTag
